const LOCALE = "pt-BR";

// numeric: "always" mantém "há 2 dias" em vez de "anteontem": a tabela
// compara linhas por varredura vertical, e o número é o que se compara.
const relativeFormatter = new Intl.RelativeTimeFormat(LOCALE, { numeric: "always" });

const fullFormatter = new Intl.DateTimeFormat(LOCALE, {
  day: "numeric",
  month: "long",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit",
});

// Fixado em UTC: due_date vem do Redmine como data sem hora, e interpretá-la
// no fuso local recuaria um dia em qualquer offset negativo.
const shortFormatter = new Intl.DateTimeFormat(LOCALE, {
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
  timeZone: "UTC",
});

const MINUTE = 60;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;
const MONTH = 30 * DAY;
const YEAR = 365 * DAY;

function parse(value) {
  if (!value) return null;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function formatRelativeDate(value, now = new Date()) {
  const date = parse(value);
  if (!date) return null;

  const elapsedSeconds = Math.round((now.getTime() - date.getTime()) / 1000);
  if (elapsedSeconds < MINUTE) return "agora mesmo";

  const [unit, seconds] =
    elapsedSeconds < HOUR
      ? ["minute", MINUTE]
      : elapsedSeconds < DAY
        ? ["hour", HOUR]
        : elapsedSeconds < MONTH
          ? ["day", DAY]
          : elapsedSeconds < YEAR
            ? ["month", MONTH]
            : ["year", YEAR];

  return relativeFormatter.format(-Math.floor(elapsedSeconds / seconds), unit);
}

export function formatFullDate(value) {
  const date = parse(value);
  return date ? fullFormatter.format(date) : null;
}

export function formatShortDate(value) {
  const date = parse(value);
  return date ? shortFormatter.format(date) : null;
}
